module.exports = __webpack_public_path__ + "media/closing_alert.d66670f1.mp3";